import styled from "styled-components";
import { setFont } from "@similarweb/styles";
import { colorsPalettes, rgba } from "@similarweb/styles";
import { SWReactIcons } from "@similarweb/icons";
import I18n from "pro-features/components/WithTranslation/src/I18n";
import { Button } from "@similarweb/ui-components";

export const Title = styled.span`
    ${setFont({ $size: 16, $weight: 400, $color: colorsPalettes.carbon[400] })};
`;

const BoldTitle = styled.span`
    ${setFont({ $size: 16, $weight: 700, $color: colorsPalettes.carbon[400] })};
`;
export const InputContainer = styled.div<{ hasSelected: boolean }>`
    padding: 16px 0 16px 0;
    .input-container {
        ${({ hasSelected }) => hasSelected && `border-radius: 0 0 3px 3px`};
    }
`;

export const InputStyle = styled.div`
    border: 1px solid ${colorsPalettes.carbon[100]};
    border-radius: 3px 3px 0 0;
    border-bottom: 0;
    padding: 4px 10px;
    .ChipItemText {
        ${setFont({ $size: 13, $weight: 400, $color: colorsPalettes.carbon[500] })};
    }
`;
export const ChipWrapper = styled.div`
    cursor: pointer;
`;

export const ChipContainerWrapper = styled.div`
    .ChipItemText {
        max-width: 200px;
    }
`;
export const TopContainer = styled.div`
    padding: 30px 24px 24px;
    border-bottom: 1px solid ${colorsPalettes.carbon[100]};
`;

export const TextfieldWrapper = styled.div`
    width: 460px;
`;

export const FooterStyle = styled.div`
    display: flex;
    justify-content: flex-end;
    padding: 8px 16px;
`;

export const ExcludeChipContainer = styled.div`
    .ChipItemText {
        text-decoration: line-through;
    }
`;

const AutocompleteKeywordGroupsStyled = styled.div<{ hasSelected: boolean }>`
    margin: 16px 0 16px 0;
    .AutoCompleteContainer {
        border-color: ${rgba(colorsPalettes.carbon[500], 0.2)};
        ${({ hasSelected }) => hasSelected && `border-radius: 0 0 3px 3px`};
    }
`;

const AutoCompleteItemsContainer = styled.div`
    border: 1px solid ${colorsPalettes.carbon[100]};
    border-radius: 3px 3px 0 0;
    border-bottom: 0;
    padding: 4px 10px;
`;

export const StyledI18n = styled(I18n)`
    display: flex;
`;
export const CloseButton = styled(Button)`
    margin-right: 8px;
`;
export const I18nKeyCountStyle = styled.span`
    display: inline-block;
    max-width: 80px;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const SWReactIconsWrapper = styled(SWReactIcons)`
    margin-right: 14px;
`;
